import type { TableMergedState } from 'components/Table/model/TableModel';
import { selectRenderedColumnWidths } from 'components/Table/model/selectors/selectRenderedColumnWidths';
import { selectVisibleColumns } from 'components/Table/model/selectors/selectVisibleColumns';
import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { createSelector } from 'reselect';
import { sum } from 'utils/number/sum';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectVisibleColumnsWidth: (s: TableMergedState) => number =
  createScopedSelector(() =>
    createSelector(
      selectVisibleColumns,
      selectRenderedColumnWidths,
      (columns, renderedColumnWidths) =>
        pipe(
          columns,
          array.map((column) => renderedColumnWidths[column.key] ?? 0),
          sum,
        ),
    ),
  );
